import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import MachineCategoryEditor from '../../_components/machineCategoryEditor';

import {
  namespace as MachineCategoriesNamespace,
  ActionTypes as MachineCategoriesActionTypes,
} from '../../store.types';

const dataLoadingOptions = {
  getterName: MachineCategoriesActionTypes.GET_MACHINE_CATEGORIES,
  contentName: 'machineCategories',
  searchable: false,
  paged: false,
};

const machineCategoriesHeaders = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'MachineCategories',

  mixins: [
    useDataLoading(dataLoadingOptions),
  ],

  components: {
    MachineCategoryEditor,
  },

  data() {
    return {
      editorDialog: false,
      isEditorCreateMode: true,
      editedMachineCategory: '',
      machineCategoriesHeaders,
    };
  },

  computed: {
    ...mapState(MachineCategoriesNamespace, ['machineCategories']),
  },

  watch: {
    suffix() {
      this.$_refreshData();
    },
  },

  methods: {
    ...mapActions(MachineCategoriesNamespace, [
      MachineCategoriesActionTypes.GET_MACHINE_CATEGORIES,
    ]),

    setEditedMachineCategory(machineCategory) {
      this.editedMachineCategory = machineCategory;
      this.isEditorCreateMode = false;
      this.editorDialog = true;
    },
  },
};
